import {mapToCanActivate, Route} from '@angular/router';
import {sharedKnowledgePathDetailResolver} from '@shared/components/knowledge/resolvers/shared-knowledge-path-detail.resolver';
import {TeamAppLoginGuard, TeamWelcomeGuard} from '@team/guards';
import {sharedKnowledgeArticleDetailResolver} from '@shared/components/knowledge/resolvers/shared-knowledge-article-detail.resolver';
import {teamMenuResolver} from '@team/resolvers/team-menu.resolver';
import {getSharedIssueRoutes} from "@core/helpers/methods/core-issue-routes.helper";
import {getSharedLoginRoutes} from "@shared/components/login/helper/core-login-routes.helper";

export default [
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: '/team/logged',
  },
  {
    path: 'not-allowed',
    loadComponent: () => import('@shared/components/login/pages/not-allowed/shared-not-allowed.page').then(m => m.SharedNotAllowedPage),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'team',
  },
  {
    path: 'team',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'welcome',
        loadComponent: () => import('@team/pages/welcome/team-welcome.page').then(m => m.TeamWelcomePage),
        canActivate: mapToCanActivate([TeamWelcomeGuard]),
      },
      {
        path: 'login',
        loadComponent: () => import('@team/pages/login/team-login.page').then(m => m.TeamLoginPage)
      },
      {
        path: 'register',
        loadComponent: () => import('@team/pages/register/team-register-page').then(m => m.TeamRegisterPage)
      },
      ...getSharedLoginRoutes(),
      {
        path: 'logged',
        loadComponent: () => import('./pages/team-main.page').then(m => m.TeamMainPage),
        canActivate: mapToCanActivate([TeamAppLoginGuard]),
        children: [
          {
            path: '',
            redirectTo: 'infos',
            pathMatch: 'full',
          },
          {
            path: 'settings',
            loadComponent: () => import('@shared/pages/settings/shared-settings.page').then(m => m.SharedSettingsPage),
          },
          {
            path: 'settings/notifications',
            loadComponent: () => import('@shared/pages/notification-config/shared-notification-settings.page').then(m => m.SharedNotificationSettingsPage)
          },
          {
            path: 'infos',
            loadComponent: () => import('./pages/infos/team-info.page').then(m => m.TeamInfoPage),
          },
          {
            path: 'knowledge',
            loadComponent: () => import('./pages/knowledge/team-knowledge.page').then(m => m.TeamKnowledgePage),
            resolve: { data: teamMenuResolver },
          },
          {
            path: 'knowledge/article/:articleId',
            loadComponent: () => import('@team/pages/knowledge/pages/knowledge-article/team-knowledge-article.page').then(m => m.TeamKnowledgeArticlePage),
            resolve: { article: sharedKnowledgeArticleDetailResolver }
          },
          {
            path: 'knowledge/path/:pathId',
            loadComponent: () => import('@team/pages/knowledge/pages/knowledge-path/team-knowledge-path.page').then(m => m.TeamKnowledgePathPage),
            resolve: { detail: sharedKnowledgePathDetailResolver },
          },
          {
            path: 'knowledge/path/:pathId/exam',
            loadComponent: () => import('@team/pages/knowledge/pages/knowledge-path/team-knowledge-path.page').then(m => m.TeamKnowledgePathPage),
            resolve: { detail: sharedKnowledgePathDetailResolver },
          },
          {
            path: 'knowledge/path/:pathId/exam/:examId',
            loadComponent: () => import('@team/pages/knowledge/pages/knowledge-path/team-knowledge-path.page').then(m => m.TeamKnowledgePathPage),
            resolve: { detail: sharedKnowledgePathDetailResolver },
          },
          {
            path: 'documents',
            loadComponent: () => import('@shared/components/documents/shared-document.page').then(m => m.SharedDocumentPage),
            resolve: { data: teamMenuResolver },
          },
          {
            path: 'documents/me',
            loadComponent: () => import('@shared/components/documents/pages/personal/shared-document-personal.page').then(m => m.SharedDocumentPersonalPage),
            resolve: { data: teamMenuResolver },
          },
          {
            path: 'documents/:path',
            loadComponent: () => import('@shared/components/documents/shared-document.page').then(m => m.SharedDocumentPage),
            resolve: { data: teamMenuResolver },
            pathMatch: 'full',
          },
          ...getSharedIssueRoutes(),
          {
            path: 'issues',
            loadComponent: () => import('@team/pages/issues/team-issue.page').then(m => m.TeamIssuePage),
          },
        ]
      }
    ],
  },
] as Route[];

